import script from "./LearningPathwaysView.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningPathwaysView.vue?vue&type=script&setup=true&lang=js"

import "./LearningPathwaysView.vue?vue&type=style&index=0&id=2ac08167&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac08167"]])

export default __exports__